<template>
  <div class="rounded">
   <form class="w-full" @submit.prevent>
    <div>
      <v-date-picker
        color="orange"
        v-model="newRange"
        mode="dateTime"
        v-on:popoverDidHide="updateDate"
        :masks="masks"
        is-range is24hr>

        <template v-slot="{ inputValue, inputEvents, isDragging, togglePopover }">
          <div>
            <div class="mt-1 flex rounded-md shadow-sm">
              <div class="relative flex items-stretch flex-grow focus-within:z-10">
                <input
                  :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                  :value="`${inputValue.start} -> ${inputValue.end}`"
                  v-on="inputEvents.start" type="text"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300 text-center w-full" disabled />
              </div>
              <button @click="togglePopover({ placement: 'auto-start' })" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                <!-- Heroicon name: sort-ascending -->
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            </button>
          </div>
          </div>
        </template>
      </v-date-picker>
    </div>
  </form>
</div>
</template>


<script>
export default {
  props: {
    range: {
      type: Object
    }
  },
  data() {
    return {
      newRange: this.range,
      masks: {
        input: 'DD/MM/YYYY h:mm A',
      },
    }
  },
  created() {
    this.range.start = this.innerStart
    this.range.end = this.innerEnd
  },
  computed: {
    innerStart() {
      return this.$store.getters.innerStart
    },
    innerEnd() {
      return this.$store.getters.innerEnd
    }
  },
  watch: {
    range(value) {
      this.newRange = value
    },
  },
  methods: {
    updateDate() {
      this.$emit('update-datetime-picker')
      this.$store.dispatch('updateInnerStart', this.newRange.start)
      this.$store.dispatch('updateInnerEnd', this.newRange.end)
    },
  }

}
</script>
